import React from 'react';
import { Link } from 'gatsby';
import { LANDING, HOME, ACCOUNT, ONBOARD } from '../../../../constants/routes';
import SignOutButton from './SignOutButton';

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

export default class NavigationAuth extends React.Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }
  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }
  render() {
    return (
  <div className="navbar">
    <div className="navbar__inner">
      <div className="navbar__left">
        <div className="navbar__links">
          {/* <div className="navbar__link">
            <Link to={LANDING}>Landing</Link>
          </div> */}
          <div className="navbar__link">
            <Link to={HOME}>Project</Link>
          </div>
        </div>
      </div>

      <div className="navbar__user">
        <div className="navbar__item">

          <Dropdown isOpen={this.state.dropdownOpen}  onClick={this.toggle}>
            <DropdownToggle tag="a" className="navbar__link" caret>
              Account
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem> <Link to={ACCOUNT}>Account Settings</Link> </DropdownItem>
              <DropdownItem divider />
              <DropdownItem> <SignOutButton /> </DropdownItem>
            </DropdownMenu>
          </Dropdown>

        </div>
      </div>
    </div>
  </div>
   );
  }
}

